import { render, staticRenderFns } from "./adSeries.vue?vue&type=template&id=65a27942"
import script from "./adSeries.vue?vue&type=script&lang=js"
export * from "./adSeries.vue?vue&type=script&lang=js"
import style0 from "./adSeries.vue?vue&type=style&index=0&id=65a27942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports